import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';
import Menu from "./service/Menu";

const routes = [
    
    {
        path: '/dashboard',
        name: 'app',
        component: App,
        children: [
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('./components/Dashboard.vue')
            },
            {
                path: '/userProfile',
                name: 'userProfile',
                component: () => import('./pages/UserProfile.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('./components/menu/UserRides.vue')
                    }
                ]
            },
            {
                path: '/profile',
                meta: {
                    authRequires: true
                },
                name: 'profile',
                component: () => import('./pages/profile.vue')
            },
            {
                path: '/ClientDashboard',
                meta: {
                    authRequires: true
                },
                name: 'ClientDashboard',
                component: () => import('./pages/ClientDashboard.vue')
            },
            {
                path: '/FleetManagerDashboard',
                meta: {
                    authRequires: true
                },
                name: 'FleetManagerDashboard',
                component: () => import('./pages/FleetManagerDashboard.vue')
            },
            {
                path: '/FleetProfile',
                meta: {
                    authRequires: true
                },
                name: 'FleetProfile',
                component: () => import('./pages/FleetProfile.vue')
            },
            {
                path: '/CorporateDashboard',
                meta: {
                    authRequires: true
                },
                name: 'CorporateDashboard',
                component: () => import('./pages/CorporateDashboard.vue')
            },
            {
                path: '/SbmDashboard',
                meta: {
                    authRequires: true
                },
                name: 'SbmDashboard',
                component: () => import('./pages/SbmDashboard.vue')
            },
            {
                path: '/SbmCeoDashboard',
                meta: {
                    authRequires: true
                },
                name: 'SbmCeoDashboard',
                component: () => import('./pages/SbmCeoDashboard.vue')
            },
            {
                path: '/district_master',
                meta: {
                    authRequires: true
                },
                name: 'district_master',
                component: () => import('./pages/district_master.vue')
            },
            {
                path: '/block_master',
                meta: {
                    authRequires: true
                },
                name: 'block_master',
                component: () => import('./pages/block_master.vue')
            },
            {
                path: '/village_master',
                meta: {
                    authRequires: true
                },
                name: 'village_master',
                component: () => import('./pages/village_master.vue')
            },
            {
                path: '/family_list',
                meta: {
                    authRequires: true
                },
                name: 'family_list',
                component: () => import('./pages/family_list.vue')
            },
            {
                path: '/complaint_master',
                meta: {
                    authRequires: true
                },
                name: 'complaint_master',
                component: () => import('./pages/complaint_master.vue')
            },
            {
                path: '/complaint_type_master',
                meta: {
                    authRequires: true
                },
                name: 'complaint_type_master',
                component: () => import('./pages/complaint_type_master.vue')
            },
            {
                path: '/complaint_status_master',
                meta: {
                    authRequires: true
                },
                name: 'complaint_status_master',
                component: () => import('./pages/complaint_status_master.vue')
            },
            {
                path: '/TransportDashboard',
                meta: {
                    authRequires: true
                },
                name: 'TransportDashboard',
                component: () => import('./pages/TransportDashboard.vue')
            },
            {
                path: '/Service',
                meta: {
                    authRequires: true
                },
                name: 'Service',
                component: () => import('./pages/Service.vue')
            },
            {
                path: '/Servicerequest',
                meta: {
                    authRequires: true
                },
                name: 'Servicerequest',
                component: () => import('./pages/Servicerequest.vue')
            },
            {
                path: '/usermaster',
                meta: {
                    authRequires: true
                },
                name: 'usermaster',
                component: () => import('./pages/UserMaster.vue')
            },
            {
                path: '/fleetmangermaster',
                meta: {
                    authRequires: true
                },
                name: 'fleetmangermaster',
                component: () => import('./pages/FleetManagerMaster.vue')
            },
            {
                path: '/clientmaster',
                meta: {
                    authRequires: true
                },
                name: 'clientmaster',
                component: () => import('./pages/ClientMaster.vue')
            },
            
            {
                path: '/sosalertmaster',
                meta: {
                    authRequires: true
                },
                name: 'sosalertmaster',
                component: () => import('./pages/SOSAlertMaster.vue')
            },
            {
                path: '/pushnotificationmaster',
                meta: {
                    authRequires: true
                },
                name: 'pushnotificationmaster',
                component: () => import('./pages/PushNotificationMaster.vue')
            },
            {
                path: '/groupmaster',
                meta: {
                    authRequires: true
                },
                name: 'groupmaster',
                component: () => import('./pages/GroupMaster.vue')
            },
            {
                path: '/role_master',
                meta: {
                    authRequires: true
                },
                name: 'role_master',
                component: () => import('./pages/role_master.vue')
            },
            {
                path: '/menu_master',
                meta: {
                    authRequires: true
                },
                name: 'menu_master',
                component: () => import('./pages/menu_master.vue')
            },
            {
                path: '/media_master',
                meta: {
                    authRequires: true
                },
                name: 'media_master',
                component: () => import('./pages/media_master.vue')
            },
            {
                path: '/user_add',
                meta: {
                    authRequires: true
                },
                name: 'user_add',
                component: () => import('./pages/user_add.vue')
            },
            {
                path: '/user_edit',
                meta: {
                    authRequires: true
                },
                name: 'user_edit',
                component: () => import('./pages/user_edit.vue')
            },
            {
                path: '/fleet_add',
                meta: {
                    authRequires: true
                },
                name: 'fleet_add',
                component: () => import('./pages/fleet_add.vue')
            },
            {
                path: '/client_add',
                meta: {
                    authRequires: true
                },
                name: 'client_add',
                component: () => import('./pages/client_add.vue')
            },
            {
                path: '/vehicle_add',
                meta: {
                    authRequires: true
                },
                name: 'vehicle_add',
                component: () => import('./pages/vehicle_add.vue')
            },
            {
                path: '/vehicle_edit',
                meta: {
                    authRequires: true
                },
                name: 'vehicle_edit',
                component: () => import('./pages/vehicle_edit.vue')
            },
            {
                path: '/hire_vehicle',
                meta: {
                    authRequires: true
                },
                name: 'hire_vehicle',
                component: () => import('./pages/hire_vehicle.vue')
            },
            {
                path: '/hire_vehicle_master',
                meta: {
                    authRequires: true
                },
                name: 'hire_vehicle_master',
                component: () => import('./pages/hire_vehicle_master.vue')
            },
            {
                path: '/client_department',
                meta: {
                    authRequires: true
                },
                name: 'client_department',
                component: () => import('./pages/client_department.vue')
            },
            {
                path: '/DepartmentProfile',
                meta: {
                    authRequires: true
                },
                name: 'DepartmentProfile',
                component: () => import('./pages/DepartmentProfile.vue')
            },
            {
                path: '/groupProfile',
                name: 'groupProfile',
                component: () => import('./pages/GroupProfile.vue'),
                // children: [
                //     {
                //         path: '',
                //         component: () => import('./components/menu/UserRides.vue')
                //     }
                // ]
            },
            {
                path: '/serviceProfile',
                name: 'serviceProfile',
                component: () => import('./pages/ServiceProfile.vue'),
                // children: [
                //     {
                //         path: '',
                //         component: () => import('./components/menu/UserRides.vue')
                //     }
                // ]
            },
            {
                path: '/vehicleprofile',
                name: 'vehicleprofile',
                component: () => import('./pages/vehicleprofile.vue'),
                // children: [
                //     {
                //         path: '',
                //         component: () => import('./components/menu/UserRides.vue')
                //     }
                // ]
            },
            {
                path: '/TestingUI',
                name: 'TestingUI',
                component: () => import('./pages/TestingUI.vue'),
               
            },
            {
                path: '/clientProfile',
                name: 'clientProfile',
                component: () => import('./pages/ClientProfile.vue'),
               
            },
            {
                path: '/formlayout',
                meta: {
                    authRequires: true
                },
                name: 'formlayout',
                component: () => import('./components/FormLayoutDemo.vue')
            },
            {
                path: '/input',
                meta: {
                    authRequires: true
                },
                name: 'input',
                component: () => import('./components/InputDemo.vue')
            },
            {
                path: '/floatlabel',
                meta: {
                    authRequires: true
                },
                name: 'floatlabel',
                component: () => import('./components/FloatLabelDemo.vue')
            },
            {
                path: '/invalidstate',
                meta: {
                    authRequires: true
                },
                name: 'invalidstate',
                component: () => import('./components/InvalidStateDemo.vue')
            },
            {
                path: '/button',
                meta: {
                    authRequires: true
                },
                name: 'button',
                component: () => import('./components/ButtonDemo.vue')
            },
            {
                path: '/table',
                meta: {
                    authRequires: true
                },
                name: 'table',
                component: () => import('./components/TableDemo.vue'),
                
            },
            
            {
                path: '/table',
                meta: {
                    authRequires: true
                },
                name: 'table',
                component: () => import('./components/TableDemo.vue'),
                
            },
            
            
            {
                path: '/map',
                meta: {
                    authRequires: true
                },
                name: 'map',
                component: () => import('./pages/MapDemo.vue'),
                
            },
            {
                path: '/list',
                meta: {
                    authRequires: true
                },
                name: 'list',
                component: () => import('./components/ListDemo.vue')
            },
            {
                path: '/tree',
                meta: {
                    authRequires: true
                },
                name: 'tree',
                component: () => import('./components/TreeDemo.vue')
            },
            {
                path: '/panel',
                meta: {
                    authRequires: true
                },
                name: 'panel',
                component: () => import('./components/PanelsDemo.vue')
            },
            {
                path: '/overlay',
                meta: {
                    authRequires: true
                },
                name: 'overlay',
                component: () => import('./components/OverlayDemo.vue')
            },
            {
                path: '/media',
                meta: {
                    authRequires: true
                },
                name: 'media',
                component: () => import('./components/MediaDemo.vue')
            },
            {
                path: '/menu',
                component: () => import('./components/MenuDemo.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('./components/menu/PersonalDemo.vue')
                    },
                    {
                        path: '/menu/seat',
                        component: () => import('./components/menu/SeatDemo.vue')
                    },
                    {
                        path: '/menu/payment',
                        component: () => import('./components/menu/PaymentDemo.vue')
                    },
                    {
                        path: '/menu/confirmation',
                        component: () => import('./components/menu/ConfirmationDemo.vue')
                    },
                ],
            },
            {
                path: '/messages',
                meta: {
                    authRequires: true
                },
                name: 'messages',
                component: () => import('./components/MessagesDemo.vue')
            },
            {
                path: '/file',
                meta: {
                    authRequires: true
                },
                name: 'file',
                component: () => import('./components/FileDemo.vue')
            },
            {
                path: '/chart',
                meta: {
                    authRequires: true
                },
                name: 'chart',
                component: () => import('./components/ChartDemo.vue')
            },
            {
                path: '/misc',
                meta: {
                    authRequires: true
                },
                name: 'misc',
                component: () => import('./components/MiscDemo.vue')
            },
            {
                path: '/crud',
                meta: {
                    authRequires: true
                },
                name: 'crud',
                component: () => import('./pages/CrudDemo.vue')
            },
            
            {
                path: '/vehiclemaster',
                meta: {
                    authRequires: true
                },
                name: 'vehiclemaster',
                component: () => import('./pages/VehicleMaster.vue')
            },
            {
                path: '/sbmreport',
                meta: {
                    authRequires: true
                },
                name: 'sbmreport',
                component: () => import('./pages/SbmReport.vue')
            },
            {
                path: '/ridemaster',
                meta: {
                    authRequires: true
                },
                name: 'RideMaster',
                component: () => import('./pages/RideMaster.vue')
            },
            {
                path: '/ridedetails',
                meta: {
                    authRequires: true
                },
                name: 'RideDetails',
                component: () => import('./pages/RideDetails.vue')
            },
            
            {
                path: '/blocks',
                meta: {
                    authRequires: true
                },
                name: 'blocks',
                component: () => import('./components/BlocksDemo.vue')
            },
            {
                path: '/icons',
                meta: {
                    authRequires: true
                },
                name: 'icons',
                component: () => import('./components/IconsDemo.vue')
            }
            
        ]
    },
    {
        path: '/',
        name: 'login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: '/landing',
        name: 'landing',
        component: () => import('./pages/LandingDemo.vue')
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue')
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('./pages/NotFound.vue')
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue')
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


//var page_name = this.$route.name;
var user_name = localStorage.getItem("user_key");
var Menu_master = null;
var autoValue =null;
Menu_master = new Menu();

//router.beforeEach((to, from, next) => {
   
    // if (to.meta.authRequires) 
    // {  
        
    //     if (user_name == "admin") 
    //     { 
    //     Menu_master.get_menuAdmin().then((Admin_data) => {
    //     autoValue = Admin_data;
    //     if (autoValue.indexOf(to.name.toString()) !== -1) {console.log(user_name);next();} else {console.log(user_name);next('/access');}
    //     });
      
    //     } 
    //     else if (user_name == "teacher") 
    //     { 
    //     Menu_master.get_menuTeacher().then((Teacher_data) => {
    //     autoValue = Teacher_data;
    //     if (autoValue.indexOf(to.name.toString()) !== -1) {console.log(user_name);next();} else {console.log(user_name);next("/access");}
    //      });
      
    //     } 
    //     else if (user_name == "assteacher") 
    //     { 
    //     Menu_master.get_menuassistantTeacher().then((Ass_Teacher_data) => {
    //     autoValue = Ass_Teacher_data;
        
    //     if (autoValue.indexOf(to.name.toString()) !== -1) {console.log(user_name); next();} else {console.log(user_name);next("/access");}
    //     });
      
    //     } 
    //     else if (user_name == "network")
    //     { 
    //     Menu_master.get_menunetwork().then((Network_data) => {
    //     autoValue = Network_data;
    //     if (autoValue.indexOf(to.name.toString()) !== -1) {console.log(user_name);next();} else {console.log(user_name);next("/access");}
    //     });
     
    //     }
    //     else if (user_name == "student")
    //     { 
    //     Menu_master.get_menuStudent().then((Student_data) => {
    //     autoValue = Student_data;
    //     if (autoValue.indexOf(to.name.toString()) !== -1) {console.log(user_name);next();} else {console.log(user_name);next("/access");}
    //     });
     
    //     }


    // }
    // else{

    // next();
    // }

    //next();

//});

export default router;
